import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/libs/utils";

type Props = {
  className: string;
  label: string;
};

export default function LabelWithTooltip({ className, label }: Props) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn("truncate max-w-fit block cursor-default", className)}
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="max-w-xs whitespace-pre-wrap break-words">{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
